import type { HydratedModulesById, PublicationState } from "~types/types";
import { PublishedState } from "~types/wardenclyffe";

type ModulesApiRequest = {
    pageId: string;
    moduleIds: string;
    moduleVariations?: string;
    moduleTypes: string;
    locale?: string;
    publishedState?: PublicationState;
    preview?: boolean;
};

export async function fetchModulesFromApi({
    pageId,
    moduleIds,
    moduleVariations = "default",
    moduleTypes,
    locale = "en",
    publishedState = PublishedState.Published,
    preview = false,
}: ModulesApiRequest) {
    const modulesResponse = await fetch(
        `/lineup-next/api/page/${pageId}/module/${moduleIds}?moduleVariations=${moduleVariations}&moduleTypes=${moduleTypes}&locale=${locale}&publishedState=${publishedState}${
            preview ? `&inPreview=true` : ""
        }`
    );

    if (!modulesResponse.ok) {
        throw new Error(modulesResponse.statusText);
    }

    return (await modulesResponse.json()) as HydratedModulesById;
}
